import router from 'router'

class OverviewInterface{
    constructor(){
        this.linkedtype = null
        this.linkedid = null
        this.mappingName = null
        this.mapping = null
        this.fetchRoute = null
    }

    setMappingName(){
        this.mappingName = this.linkedtype.substr(0, 1).toUpperCase() + this.linkedtype.substr(1)
    }

    getMapping() {
        if (!this.mappingName){
            throw new Error('mappingName method must not be null.');
        }
        if (!this.mapping){
            this.mapping = require(`vcomponents/overview/tabs/mapping/${this.mappingName}Mapping`);
        }
        return this.mapping
    }

    fetch(id){
        if (this.linkedtype && id && this.fetchRoute) {
            this.linkedid = id
            return new Promise((resolve, reject) => {
                window.SellsyJS.WebServiceCaller.get(router.resolve({ name: this.fetchRoute, params: { id: id, type: this.linkedtype } }).href, {},
                    (response) => {
                        resolve(response)
                    },
                    (error) => {
                        reject(error)
                    }
                );

            })
        } else {
            throw new Error('Overview: linkedtype or linkedid is missing.');
        }
    }

    getNav() {
        return this.getMapping().navMap
    }
    getData() {
        return this.getMapping().dataMap
    }
    getHeaderActions() {
        return this.getMapping().headerActions
    }
    getBacklink() {
        return this.getMapping().backlink
    }
    getObject() {
        return this.getMapping().object
    }
    getRoutes() {
        return this.getMapping().routes
    }
    getAvailableStatCards() {
        return this.getMapping().availableStatCards
    }
    getDatabots() {
        return this.getMapping().databots
    }
    getAgendaViewConfig(){
        return this.getMapping().agendaViewConfig
    }
    getMoreNav() {
        return this.getMapping().moreNav
    }
    checkUrlByNavMapping(url) {
        return !!this.getNav()[0].items.find(item => item.id === url);
    } 
}

export default OverviewInterface